

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import KnowledgeCheckEvents from '@/author/components/KnowledgeCheckParts/KnowledgeCheckEvents.vue';
import {KNOWLEDGE_CHECK_EVENTS} from '@/author/constants';

@Component
export default class FreeTextQuestion extends Vue {
    @Prop() question?: string;
    @Prop() description?: string;
    @Prop() suggestedAnswer?: string;
    @Prop() answerLabel?:string
    @Prop() answerPlaceholder?:string;
    @Prop() showFeedback?:boolean;
    @Prop() color?: string;
    @Prop() userAnswer?: string;
    @Prop() userAnswerTitle?: string;
    @Prop() suggestedAnswerTitle?: string;
    @Prop() size!: string;
    answer:string = '';
    mounted(){
      KnowledgeCheckEvents.$emit(KNOWLEDGE_CHECK_EVENTS.MOUNTED, this.freeTextQuestionInfo);
    }
    handleAnswerChange(){
      KnowledgeCheckEvents.$emit(KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED, this.freeTextQuestionInfo);
    }
    beforeDestroy(){
      KnowledgeCheckEvents.$off([KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED, KNOWLEDGE_CHECK_EVENTS.MOUNTED]);
    }
    get freeTextQuestionInfo(){
      return {
        question : this.question,
        description: this.description,
        color: this.$parent.$props.color,
        suggestedAnswer: this.suggestedAnswer,
        userAnswer: this.answer,
        groupTitle: this.$parent.$props.title,
        groupDescription: this.$parent.$props.groupDescription,
        suggestedAnswerTitle: this.suggestedAnswerTitle,
        userAnswerTitle: this.userAnswerTitle,
        uid : this.uid
      };
    }
}
